import React from "react";
import SingleFeature from "./singe_feature";
import { FEATURE_LIST } from "./util";
import styles from "./index.module.scss";
import classNames from "classnames";

/**
 * 特性
 */
export default function Feature() {
  return (
    <section className={styles.wrapper}>
      <h1 className={classNames(styles.title, styles.featureMainTitle)}>
        <span className={classNames(styles.leftBar, "mr-[24px]")}></span>
        我们能做什么？
        <span className={classNames(styles.rightBar, "ml-[4px]")}></span>
      </h1>
      <div className={styles.list}>
        {FEATURE_LIST.map((item) => (
          <div className={styles.featureItem} key={item.title}>
            <SingleFeature data={item} />
          </div>
        ))}
      </div>
    </section>
  );
}
